import styled from "styled-components";
import Typography from "../../Typography";

export const ContentStack = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: ${({ theme }) => theme.sizing.md};
`;

export const BlockHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	padding: ${({ theme }) => theme.sizing.sm};
	padding-bottom: 0;

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		// padding: 12px;
	}
`;

export const BlockHeaderContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	padding-bottom: ${({ theme }) => theme.sizing.sm};
	border-bottom: 1px solid ${({ theme }) => theme.border.defaultWeak};
	gap: 4px;

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		// padding-bottom: ${({ theme }) => theme.sizing.sm};
	}
`;

export const DeleteAccountBlockHeader = styled(BlockHeader)`
	border: none;
	padding: 0;
`;

export const SettingsBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	width: 100%;
	background: ${({ theme }) => theme.fill.defaultMain};
	overflow: hidden;
`;

export const DeleteAccountBlock = styled(SettingsBlock)`
	border-top: 1px solid ${({ theme }) => theme.border.defaultWeak};
	border-radius: 0;
	padding: ${({ theme }) => theme.sizing.lg} 0 ${({ theme }) => theme.sizing.sm};
	gap: ${({ theme }) => theme.sizing.sm};
`;

export const UserAvatar = styled.img`
	width: 48px;
	height: 48px;
	border-radius: ${({ theme }) => theme.radius.xs};
	object-fit: cover;
`;

export const AccountContainer = styled.div`
	display: flex;
	width: 100%;
	padding: ${({ theme }) => theme.sizing.sm};

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		padding: 12px;
	}
`;

export const AccountBlock = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.sizing.sm};
`;

export const UserDescription = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AvatarPlaceholder = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 48px;
	height: 48px;
	border-radius: ${({ theme }) => theme.radius.xs};
	background-color: ${({ theme }) => theme.fill.defaultWeak};
`;

export const SettingsSectionBody = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0;
	padding: 0;
`;

export const SettingsSummaryRow = styled.button`
	display: flex;
	width: 100%;
	align-items: flex-start;
	justify-content: space-between;
	gap: ${({ theme }) => theme.sizing.sm};
	padding: ${({ theme }) => theme.sizing.md} 0;
	border: none;
	border-bottom: 1px solid ${({ theme }) => theme.border.defaultWeak};
	border-radius: 0;
	background: transparent;
	cursor: pointer;
	text-align: left;
`;

export const SettingsRowAction = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.sizing.xs};
	color: ${({ theme }) => theme.colors.defaultStrong};
	flex-shrink: 0;
`;

export const PrefsForm = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0;
	padding: 0;
	padding-bottom: ${({ theme }) => theme.sizing.sm};
`;

export const SettingsSection = styled.div`
	display: flex;
	flex-direction: column;
	background: transparent;
	padding: 0 ${({ theme }) => theme.sizing.sm};
`;

export const SettingsLayout = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: ${({ theme }) => theme.sizing.sm};
	padding: ${({ theme }) => theme.sizing.md} 0;
	border-bottom: 1px solid ${({ theme }) => theme.border.defaultWeak};

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		flex-wrap: wrap;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

export const SettingsLayoutVertical = styled(SettingsLayout)`
	flex-direction: column;
`;

export const SettingsLayoutActions = styled.div`
	margin-left: auto;
	flex-shrink: 0;

	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		margin-left: 0;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		align-self: flex-end;
	}
`;

export const AccountSection = styled(SettingsSection)``;

export const BillingSection = styled(SettingsSection)``;

export const NotificationSection = styled(SettingsSection)``;

export const NotificationRowButton = styled.button`
	display: flex;
	width: 100%;
	align-items: flex-start;
	justify-content: space-between;
	gap: ${({ theme }) => theme.sizing.sm};
	padding: ${({ theme }) => theme.sizing.md} 0;
	border: none;
	background: transparent;
	cursor: pointer;
	text-align: left;
`;

export const NotificationRowCopy = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`;

export const NotificationSectionPanel = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.sizing.sm};
	padding: 0 0 ${({ theme }) => theme.sizing.lg};
`;

export const ChevronIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	transform: rotate(${({ $open }) => ($open ? "180deg" : "0deg")});
	transition: transform 0.2s ease;
`;

export const PrefsRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.sizing.xs};
`;

export const InlineStatus = styled(Typography)`
	color: ${({ theme }) => theme.colors.defaultWeak};
`;

export const EmptyStateText = styled(Typography).attrs({
	as: "p",
	$variant: "body-2-medium",
})`
	padding: ${({ theme }) => theme.sizing.sm};
	color: ${({ theme }) => theme.colors.defaultWeak};
`;

export const NearbySettings = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: ${({ theme }) => theme.sizing.sm};
	padding: ${({ theme }) => theme.sizing.sm};
	border: 1px solid ${({ theme }) => theme.border.defaultWeak};
	background: ${({ theme }) => theme.fill.defaultSubtle};
	border-radius: ${({ theme }) => theme.radius.xs};
`;
